export default __webpack_public_path__ + "static/media/flechaVerde.9c89ed12.svg";